const Footer = () => {
	return <footer className="bg-dark py-5"></footer>;
};

export default Footer;
